import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import { Select, Button, BUTTON_THEME, Icon, BUTTON_SIZE } from '@st-operations/uikit/src/v2'
import MultiValueInput from '_components/multi-value-input/index.jsx'

import './PartnersCpm.scss'

const PartnersCpm = ({ schema, cpmRates, setCpmRates, setHasChanges }) => {
  const handleChangePartner = (idRef) => (newPartnersId) => {
    setHasChanges(true)
    const idsUnique = [...new Set(newPartnersId)]
    setCpmRates((cpmRates) =>
      cpmRates.map(({ id, cpm, partnersId }) => {
        if (id === idRef) {
          return { id, cpm, partnersId: idsUnique }
        }
        return { id, cpm, partnersId: partnersId.filter((id) => !idsUnique.includes(id)) }
      })
    )
  }

  const handleChangeCPM = (idRef) => (newCpm) => {
    setHasChanges(true)
    setCpmRates((cpmRates) =>
      cpmRates.map(({ id, cpm, partnersId }) => {
        if (id === idRef) {
          return { id, cpm: newCpm, partnersId }
        }
        return { id, cpm, partnersId }
      })
    )
  }

  const handleNewCPMRate = () => {
    setCpmRates((rates) => [
      ...rates,
      { id: rates.length, cpm: schema.cpmRate.default, partnersId: [] },
    ])
  }

  if (!cpmRates) return null

  return (
    <div className="partners-cpm">
      <div className="partners-cpm__items">
        <label className="st-input__label">Partner IDs</label>
        <label className="st-input__label">CPM Rate</label>
        {cpmRates.map(({ id, cpm, partnersId }) => (
          <Fragment key={id}>
            <MultiValueInput values={partnersId} onChange={handleChangePartner(id)} />
            <Select value={cpm} onChange={handleChangeCPM(id)} options={schema.cpmRate.enum} />
          </Fragment>
        ))}
      </div>
      <Button
        theme={BUTTON_THEME.GHOST}
        size={BUTTON_SIZE.SMALL}
        onClick={handleNewCPMRate}
        className="partners-cpm__button"
      >
        <Icon width="18px" height="18px" icon="add" type="fill" color="currentColor" />
        Add New CPM Rate
      </Button>
    </div>
  )
}

PartnersCpm.propTypes = {
  schema: PropTypes.shape().isRequired,
  cpmRates: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      cpm: PropTypes.string,
      partnersId: PropTypes.arrayOf(PropTypes.string),
    })
  ).isRequired,
  setCpmRates: PropTypes.func.isRequired,
  setHasChanges: PropTypes.func.isRequired,
}

export default PartnersCpm
